import React, {Component} from "react";
import { connect } from 'react-redux';
import Alert from 'react-s-alert';
import 'react-s-alert/dist/s-alert-default.css';
import 'react-s-alert/dist/s-alert-css-effects/stackslide.css';

import StaffCreateForm from './StaffCreateForm';
import {addEmployee} from '../../actions/employeesActions';
import CreateCompanyMessage from "../Account/CreateCompanyMessage";

class StaffCreate extends Component {

    state = {
        email: '',
        is_admin: false,
        isFetching: false,
        balance_limit: '',
    }

    handleOnChange(value, field) {
        this.setState({
            [field]: value,
        })
    }

    onSubmit(e) {
        e.preventDefault();

        const {email, balance_limit, is_admin} = this.state;
        const {selectedCompany} = this.props;

        if(!selectedCompany || !selectedCompany.id)
            return false;

        const payload = {
            company_id: selectedCompany.id,
            email,
            balance_limit,
            is_admin
        }
        this.setState({
            isFetching: true
        })
        this.props.addEmployee(
            payload,
            (data) => {
                this.setState({
                    email: '',
                    balance_limit: '',
                    is_admin: false,
                    isFetching: false
                });
                Alert.success('Приглашение было успешно отправлено', {
                    position: 'bottom-left',
                    effect: 'stackslide',
                    timeout: 5000
                });
            },
            (message) => {
                Alert.error(message, {
                     position: 'bottom-left',
                     effect: 'stackslide',
                     timeout: 5000
                });
                this.setState({
                    isFetching: false
                })
            }
        )
    }

    render() {
        const {
            employees,
            companies,
            selectedCompany,
            handleCompany,
            session:{currentUser}
        } = this.props;

        if(!companies.data.results.length) {
            return <CreateCompanyMessage />
        }

        let options = [];
        companies.data.results.map((item, index) =>
            options.push({
                value: item.id,
                label: item.title,
            })
        );

        let isAdmin = employees.admins.results.filter(item => item.user.id === currentUser.id);

        if(!selectedCompany){
            return false;
        }

        return(
            <div className="menu-content-staff menu-content-item tab-parent screen-bottom-block">

                <Alert stack={{limit: 1}} />

                <div className="rounded-white-block">
                    <div className="white-block-top">
                        <h3>Новый сотрудник</h3>
                    </div>

                    <StaffCreateForm
                        {...this.state}
                        isAdmin={isAdmin}
                        isFetching={this.state.isFetching}
                        options={options}
                        selectedCompany={selectedCompany}
                        handleCompany={handleCompany}
                        handleOnChange={(value, field) => this.handleOnChange(value, field)}
                        onSubmit={(e) => this.onSubmit(e)}
                        />
                </div>
            </div>
        )
    }
}

const mapStateToProps = state => {
    return {
        ...state
    };
};

export default connect(mapStateToProps, {addEmployee})(StaffCreate);


// WEBPACK FOOTER //
// ./src/components/AccountLaw/StaffCreate.js